export default __webpack_public_path__ + "static/media/07.d5c25d90.png";